import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import {
  updateParams,
  updateVideoPageState,
} from "../../../Pages/Video/VideoActions";
import "./FlaggedModal.scss";
import { useNavigate } from "react-router-dom";

export default () => {
  const videoReportedAsFlagged = useSelector(
    (state) => state.videoPageStates.videoReportedAsFlagged
  );

  const isVideoDetailPage = useSelector(
    (state) => state.videoPageStates.isVideoDetailPage
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <Modal
      size="lg"
      style={{ maxWidth: "623px" }}
      isOpen={videoReportedAsFlagged}
      className="FlaggedModal modal-dialog-centered"
    >
      <ModalBody className="p-0">
        <img
          src={require("@src/assets/images/vyrill/cross.png").default}
          alt=""
          role="button"
          width="30px"
          className="closeBtn"
          onClick={() => {
            dispatch(updateVideoPageState({ videoReportedAsFlagged: false }));
            if (isVideoDetailPage) {
              navigate("/videos");
              dispatch(updateParams({ reFetch: true }));
            }
          }}
        />
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ height: "418px" }}
        >
          <img
            src={
              require("@src/assets/images/vyrill/active-flagged.png").default
            }
            alt=""
            width="36px"
            className="flag-icon"
          />
          <p style={{ fontSize: "30px", color: "#000000" }}>
            This video has been flagged
          </p>
          {/* <LoadingDots /> */}
        </div>
      </ModalBody>
    </Modal>
  );
};
